import $ from 'jquery';

import Component from "../Component";
import CartTerms from '../global/CartTerms';

export default class CartDrawer extends Component {
    FADE_OUT_ANIMATION_DURATION = 800; // ms

    constructor(theme, element) {
        super(theme, element);

        const initial = document.querySelector('#initial-cart');
        if (!initial) {
            return;
        }
        const data = JSON.parse(initial.textContent);
        this.updateCartDrawer(data);

        this.cartTerms = new CartTerms(this.theme, this.element);

        $('.cart-button-checkout').on('click', (event) => {
            const $el = $(event.currentTarget);
            $el.find('.cart-button-checkout-text').addClass('hide');
            $el.find('.cart-button-checkout-spinner').removeClass('hide');
            this.cartTerms.checkTerms(event);
        });
    }

    /** @param {Cart} cart */
    updateCartDrawer = (cart) => {
        $('.cart-error-box').text('');

        if (cart.items.length === 0) {
            $('.cart-empty-box,.ajax-cart--total-price').removeClass('hide');
            $('.ajax-cart--total-price,.cart-button-checkout,.additional-checkout-buttons').addClass('hide');
        } else {
            $('.cart-empty-box').addClass('hide');
            $('.ajax-cart--total-price,.cart-button-checkout,.additional-checkout-buttons').removeClass('hide');
        }

        var template = $('#cart-item-template').html();
        var $cart_items = $('.cart-items');
        $cart_items.empty();
        var self = this;
        cart.items.forEach((item, index) => {
            var $cart_item = $(template);
            if (item.image) {
                $cart_item.find('.cart-item-image').attr({
                    src: item.image,
                    alt: item.product_title,
                });
            } else {
                $cart_item.find('.cart-item-image').css('display', 'none');
            }
            $cart_item.find('.cart-item-link').attr({
                href: item.url,
            });
            $cart_item.find('.cart-item-product-title').text(item.product_title);
            if(item.variant_title) {
                $cart_item.find('.cart-item-variant-title').removeClass('hide').text(item.variant_title);
            }
            $cart_item.find('.cart-item-price').html(this.theme.formatMoney(item.final_line_price));
            if (item.unit_price_measurement) {
                $cart_item.find('.cart-item-price-per-unit').html('<span class="price">(' + this.theme.formatMoney(item.unit_price) + ' / ' + (item.unit_price_measurement.reference_value != 1 ? item.unit_price_measurement.reference_value : '') + ' ' + item.unit_price_measurement.reference_unit + ')');
            } else {
                $cart_item.find('.cart-item-price-per-unit').text('');
            }
            var $original_price = $cart_item.find('.cart-item-price-original');
            if (item.original_line_price > item.final_line_price) {
                $original_price.html(this.theme.formatMoney(item.original_line_price)).show();
            } else {
                $original_price.hide();
            }
            var quantity = $cart_item.find('.cart-item-quantity');
            var quantity_wrapper = quantity.closest('.cart-item--quantity-wrapper');
            var update_quantity = (quantity) => {
                quantity_wrapper.addClass('cart-item-quantity-active');
                var fade = quantity <= 0;
                var delay = fade ? this.FADE_OUT_ANIMATION_DURATION : 0;
                this.cartSetQuantity(delay).always(() => {
                    quantity_wrapper.removeClass('cart-item-quantity-active');
                    if (fade) {
                        $cart_item.addClass('fadeOut animated fast');
                        setTimeout(function () {
                            $cart_item.remove();
                        }, this.FADE_OUT_ANIMATION_DURATION);
                    }
                });
            };
            quantity.on('change', function () {
                var new_q = parseInt($(this).val(), 10);
                update_quantity(new_q);
            });
            quantity.val(item.quantity);
            quantity.attr('name', 'updates[]');

            $cart_item.find('.cart-item-quantity-button').on('click', function () {
                var current = parseInt(quantity.val(), 10);
                var change = parseInt(this.dataset.amount, 10);
                var new_q = current + change;
                quantity.val(new_q);
                update_quantity(new_q);
            });

            var $discounts = $cart_item.find('.order-discount--cart-list').empty();

            item.line_level_discount_allocations.forEach(function (discount_allocation) {
                var $item = $('<li class="order-discount--item"></li>');
                $('<span class="order-discount--item"></span>').text(discount_allocation.discount_application.title).appendTo($item);
                $('<span class="order-discount--cart-title"></span>').html('-' + self.theme.formatMoney(discount_allocation.amount)).appendTo($item);
                $discounts.append($item);
            });

            $cart_item.appendTo($cart_items);
        });

        $('.cart-item-count, .cart-item-count-header--quantity').text(cart.item_count);
        $('.cart-total-price, .cart-item-count-header--total').html(this.theme.formatMoney(cart.total_price));

        var $original_price = $('.cart-item-original-total-price');
        if (cart.original_total_price > cart.total_price) {
            $original_price.html(this.theme.formatMoney(cart.original_total_price)).show();
        } else {
            $original_price.hide();
        }

        var $cart_discount = $('.ajax-cart-discount-wrapper').empty();
        cart.cart_level_discount_applications.forEach(function (discount_application) {
            var $item = $('<div class="cart--order-discount-wrapper--indiv"></div>');
            $('<span class="order-discount"></span>').html('-' + self.theme.formatMoney(discount_application.total_allocated_amount)).appendTo($item);
            $('<span class="order-discount--cart-title"></span>').text(discount_application.title).appendTo($item);
            $cart_discount.append($item);
        });
    }

    cartSetQuantity = (delay) => {
        var deferred = $.Deferred();

        $('.cart-error-box').text('');

        $.ajax({
            type: "POST",
            url: '/cart/update.js',
            dataType: 'json',
            data: $('.cart-drawer-form').serialize(),
        })
            .then((data) => {
                deferred.resolve();
                setTimeout(() => {
                    this.updateCartDrawer(data);
                }, delay);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                deferred.reject();
                console.error('Cart error', textStatus, jqXHR, errorThrown);
                $('.cart-error-box').empty().text('Unable to update item quantity');
            });

        return deferred;
    }
}
